module.exports = __webpack_public_path__ + "img/dropdown-menu-product-4-1.626396a9.png";